// extracted by mini-css-extract-plugin
module.exports = {"utils__Table":"lw_a pz_b pz_mh"};